import * as React from 'react';

export const VideoCameraBold = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2635 7.06413C21.6375 6.30213 20.5065 6.19113 19.7435 6.81513L18.5172 7.81907C18.2598 8.02979 18.1413 8.35331 18.1576 8.68555C18.1594 8.72365 18.1605 8.76213 18.1605 8.80113V15.2021C18.1605 15.2435 18.1593 15.2842 18.1573 15.3245C18.1405 15.6557 18.2589 15.9782 18.5151 16.1888L19.7295 17.1871C20.0455 17.4481 20.4485 17.5911 20.8635 17.5911C21.8495 17.5911 22.6545 16.7891 22.6575 15.8021L22.6695 8.20413C22.6705 7.78913 22.5275 7.38313 22.2635 7.06413Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30203 15.56H6.46203C6.05203 15.56 5.71203 15.23 5.71203 14.81C5.71203 14.4 6.05203 14.06 6.46203 14.06H9.30203C9.72203 14.06 10.052 14.4 10.052 14.81C10.052 15.23 9.72203 15.56 9.30203 15.56ZM12.472 4.25H5.68203C3.08203 4.25 1.33203 6.08 1.33203 8.8V15.2C1.33203 17.92 3.08203 19.75 5.68203 19.75H12.472C15.072 19.75 16.822 17.92 16.822 15.2V8.8C16.822 6.08 15.072 4.25 12.472 4.25Z"
      fill="#64748B"
    />
  </svg>
);
